import { callGetApiToServer } from "../callApi";

export async function getAllCourseSessionTopic(authtoken, skip, limit, courseId) {
  console.log(authtoken, limit);
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl = "v1/auth/admin/topics/topic/" + skip + "/" + limit;

    if (courseId) {
      endUrl = "v1/admin/session-topic/" + skip + "/" + limit + "/" + courseId + "/topic";
    }

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
